import { render, staticRenderFns } from "./UploadProductFiles.vue?vue&type=template&id=2a028c10&scoped=true&"
import script from "./UploadProductFiles.vue?vue&type=script&lang=js&"
export * from "./UploadProductFiles.vue?vue&type=script&lang=js&"
import style0 from "./UploadProductFiles.vue?vue&type=style&index=0&id=2a028c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a028c10",
  null
  
)

export default component.exports